export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./addStaff.vue?vue&type=template&id=8644eeda&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/addStaff.vue?vue&type=template&id=8644eeda&
// module id = 1649
// module chunks = 0